import { render, staticRenderFns } from "./pop_order_list.vue?vue&type=template&id=fbee3de4"
import script from "./pop_order_list.vue?vue&type=script&lang=js"
export * from "./pop_order_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports